import { type CustomTooltipProps } from "ag-grid-react"
import { Warning } from "@phosphor-icons/react"
import { Card, CardContent, CardHeader, CardTitle } from "~/components/reusable/Card"
import HeaderTooltip from "./HeaderTooltip"
import { formatDate } from "~/utils/datetime"

export type DelayedPoWarningTooltipValue = {
  tooltipType: "DelayedPoWarning"
  allPos: {
    poName: string
    warehouseId: string
    warehouseName: string
    poExpectedArrivalDate: Date
  }[]
}

function Divider() {
  return <div className="border-t border-base my-1" />
}

export default function DelayedPoWarningTooltip(props: CustomTooltipProps) {
  if (props.location === "header") return <HeaderTooltip {...props} />

  const value = props.value as DelayedPoWarningTooltipValue | undefined
  if (!value) return null

  return (
    <Card className="w-[260px]">
      <CardHeader>
        <CardTitle className="flex items-center gap-1.5">
          <Warning className="text-theme-warning shrink-0" size={15} />
          Delayed PO
        </CardTitle>
      </CardHeader>
      <CardContent className="flex flex-col gap-2 pb-3">
        <div className="flex flex-col gap-1">
          {value.allPos.map((po, i) => (
            <div key={i} className="flex justify-between gap-3">
              <span className="text-fg-muted paragraph-sm truncate">{po.warehouseName}</span>
              <span className="text-fg-base font-medium tabular-nums paragraph-sm shrink-0">
                {formatDate(po.poExpectedArrivalDate)}
              </span>
            </div>
          ))}
        </div>
        <Divider />
        <p className="text-fg-muted paragraph-sm">Snooze this variant instead of re-ordering.</p>
      </CardContent>
    </Card>
  )
}
